/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ApproveAllSkillSuggestionsRequestBody,
  ApproveAllSkillSuggestionsRequestBody$Outbound,
  ApproveAllSkillSuggestionsRequestBody$outboundSchema,
} from "../components/approveallskillsuggestionsrequestbody.js";

export type ApproveAllSkillSuggestionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ApproveAllSkillSuggestionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ApproveAllSkillSuggestionsSecurity = {
  option1?: ApproveAllSkillSuggestionsSecurityOption1 | undefined;
  option2?: ApproveAllSkillSuggestionsSecurityOption2 | undefined;
};

export type ApproveAllSkillSuggestionsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  approveAllSkillSuggestionsRequestBody?:
    | ApproveAllSkillSuggestionsRequestBody
    | undefined;
};

/** @internal */
export type ApproveAllSkillSuggestionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ApproveAllSkillSuggestionsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ApproveAllSkillSuggestionsSecurityOption1$Outbound,
    ApproveAllSkillSuggestionsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function approveAllSkillSuggestionsSecurityOption1ToJSON(
  approveAllSkillSuggestionsSecurityOption1:
    ApproveAllSkillSuggestionsSecurityOption1,
): string {
  return JSON.stringify(
    ApproveAllSkillSuggestionsSecurityOption1$outboundSchema.parse(
      approveAllSkillSuggestionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ApproveAllSkillSuggestionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ApproveAllSkillSuggestionsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ApproveAllSkillSuggestionsSecurityOption2$Outbound,
    ApproveAllSkillSuggestionsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function approveAllSkillSuggestionsSecurityOption2ToJSON(
  approveAllSkillSuggestionsSecurityOption2:
    ApproveAllSkillSuggestionsSecurityOption2,
): string {
  return JSON.stringify(
    ApproveAllSkillSuggestionsSecurityOption2$outboundSchema.parse(
      approveAllSkillSuggestionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ApproveAllSkillSuggestionsSecurity$Outbound = {
  Option1?: ApproveAllSkillSuggestionsSecurityOption1$Outbound | undefined;
  Option2?: ApproveAllSkillSuggestionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ApproveAllSkillSuggestionsSecurity$outboundSchema: z.ZodMiniType<
  ApproveAllSkillSuggestionsSecurity$Outbound,
  ApproveAllSkillSuggestionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ApproveAllSkillSuggestionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ApproveAllSkillSuggestionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function approveAllSkillSuggestionsSecurityToJSON(
  approveAllSkillSuggestionsSecurity: ApproveAllSkillSuggestionsSecurity,
): string {
  return JSON.stringify(
    ApproveAllSkillSuggestionsSecurity$outboundSchema.parse(
      approveAllSkillSuggestionsSecurity,
    ),
  );
}

/** @internal */
export type ApproveAllSkillSuggestionsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ApproveAllSkillSuggestionsRequestBody?:
    | ApproveAllSkillSuggestionsRequestBody$Outbound
    | undefined;
};

/** @internal */
export const ApproveAllSkillSuggestionsRequest$outboundSchema: z.ZodMiniType<
  ApproveAllSkillSuggestionsRequest$Outbound,
  ApproveAllSkillSuggestionsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    approveAllSkillSuggestionsRequestBody: z.optional(
      ApproveAllSkillSuggestionsRequestBody$outboundSchema,
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      approveAllSkillSuggestionsRequestBody:
        "ApproveAllSkillSuggestionsRequestBody",
    });
  }),
);

export function approveAllSkillSuggestionsRequestToJSON(
  approveAllSkillSuggestionsRequest: ApproveAllSkillSuggestionsRequest,
): string {
  return JSON.stringify(
    ApproveAllSkillSuggestionsRequest$outboundSchema.parse(
      approveAllSkillSuggestionsRequest,
    ),
  );
}
